import { render, staticRenderFns } from "./AppImage.vue?vue&type=template&id=ef579a3e&scoped=true&"
import script from "./AppImage.vue?vue&type=script&lang=js&"
export * from "./AppImage.vue?vue&type=script&lang=js&"
import style0 from "./AppImage.vue?vue&type=style&index=0&id=ef579a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef579a3e",
  null
  
)

export default component.exports